import {
  Box,
  Grid,
  Typography,
  Card,
  CardMedia,
  IconButton,
  Divider,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Salon_img from "../../assets/img/details_img.png";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Footer from "../../common/Footer"; 
import SEO from "../../common/SEO";

const services = ["Head Wash", "Haircut", "Facial", "Massage"];
export const Details = () => {
  const details = useSelector((state) => state.reducer.detail);
  const navigate = useNavigate();

  useEffect(() => {
    console.log(details, "detailsssssssssPage");
  }, [details]);

  const [openProfileDialog, setOpenProfileDialog] = useState(false);
  const [openOtpDialog, setOpenOtpDialog] = useState(false);
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);

  return (
    <>
      <SEO
        title="Elegant Prime"
        description="All in One Basic Software for billing, inventory, and business management. Perfect solution for small and medium businesses."
        keywords="All-in-One Salon Management Software – POS, CRM & Billing, Salon & Spa Software – streamline operations, retain clients, boost revenue, Billing & Inventory Management Software for salons, Appointment Scheduling App for salons & spas,
Salon CRM Software India – customer retention made easy, Online Salon Booking System for clients, Loyalty Program Features to reward & retain customers, Staff Scheduling Software – manage beauticians & salon staff with ease,
Beauty Parlour Software with GST Billing – fast, compliant billing, Cloud-based Salon Management System – access anywhere, anytime
Salon Marketplace Integration – sell beauty products & services online, Best salon management app for parlours,
Best appointment scheduling app for salons, Affordable salon management software India, Mobile app for salon business growth,
Beauty parlour software India, Salon billing software with GST, Best salon management app, Salon staff scheduling software"
        canonical="https://elegantprime.in/details"
        schema={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "All in One Basic Software",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web, Windows, Mac",
        }}
      />
      <Box>
        {/* Back Button */}

        <IconButton
          size="small"
          sx={{ mb: 2, mt: { sm: 6, xs: 1 }, mx: { sm: 10, xs: 2 } }}
          onClick={() => navigate("/salon")}
        >
          <KeyboardBackspaceIcon sx={{ color: "#01008B", fontSize: "30px" }} />
        </IconButton>
        <Container p={3}>
          {/* Image */}
          <Box display="flex" justifyContent="center" mb={3}>
            <Grid item xs={12} md={5}>
              <Box
                component="img"
                src={Salon_img}
                alt="Salon"
                sx={{
                  width: "100%",
                  height: "100%",
                  borderRadius: 2,
                  objectFit: "cover",
                }}
              />
            </Grid>
          </Box>

          {/* Title */}
          <Typography
            variant="h5"
            fontWeight="600"
            fontSize={{ sm: "30px", md: "40px", xs: "20px" }}
            mb={2}
          >
            {details.enterpriseName}{" "}
            <span style={{ fontWeight: "normal" }}>
              (B.Id - {details.billerId})
            </span>
          </Typography>

          {/* Address */}
          <Grid container spacing={4} py={5}>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="space-between"
                borderBottom="1px solid #ccc"
                py={1}
              >
                <Typography
                  color="#000"
                  fontWeight="600"
                  sx={{
                    fontSize: { xs: "14px", sm: "15px", md: "16px" },
                  }}
                >
                  Address :
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "14px" },
                  }}
                >
                  {details.address}
                </Typography>
              </Box>
            </Grid>

            {/* Details Table */}
            {[
              ["Area", details.area ?? "N/A"],
              ["District", details.district ?? "N/A"],
              ["Opening Time", details.openingTime ?? "N/A"],
              ["State", details.state ?? "N/A"],
              ["Closing Time", details.closingTime ?? "N/A"],
              ["Pin code", details.pincode ?? "N/A"],
              ["Service Available at", details.serviceFrom ?? "N/A"],
              ["Mobile Number 1", details.mobileNumber ?? "N/A"],
              ["Business Category", details.businessCategory ?? "N/A"],
              ["Mobile Number 2", details.mobileNumber2 ?? "N/A"],
              ["Branch Name", details.branchName ?? "N/A"],
              ["Mail ID 1", details.mailID1 ?? "N/A"],
              ["City", details.city ?? "N/A"],
              ["Mail ID 2", details.mailID2 ?? "N/A"],
            ].map(([label, value], index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  borderBottom="1px solid #ccc"
                >
                  <Typography
                    color="#000"
                    fontWeight="600"
                    sx={{
                      fontSize: { xs: "14px", sm: "15px", md: "16px" },
                    }}
                  >
                    {label} :
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "13px", md: "14px" },
                    }}
                  >
                    {value}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
        <Footer />
      </Box>
    </>
  );
};
